import { AxiosRequestConfig } from "axios";

import { RouteErrors } from "routes/data-routes/types";
import { BillingInputName, CouponInputName, FormInputName } from "v2/dataroutes/BillingData";

import { formDataToStructuredObject } from "utils/formDataUtils";

import { ActiveSubscriptionFormActions } from "routes/data-routes/billing-data/active-subscription/ActiveSubscriptionFormActions";
import { cancelSubscriptionAction } from "routes/data-routes/billing-data/active-subscription/actions/cancelSubscriptionAction";
import { changeSubscriptionAction } from "routes/data-routes/billing-data/active-subscription/actions/changeSubscriptionAction";
import {
  removeScheduledChangesAction
} from "routes/data-routes/billing-data/active-subscription/actions/removeScheduledChangesAction";
import { renewSubscriptionAction } from "routes/data-routes/billing-data/active-subscription/actions/renewSubscriptionAction";

import { addToasterActionData } from "hooks/useToasterFromActionData";
import { ActiveSubscriptionDataRouteType } from "routes/data-routes/billing-data/active-subscription/route.meta";


export const action: ActiveSubscriptionDataRouteType["route"]["action"] = async ({ request, params }) => {
  const formData = formDataToStructuredObject(await request.formData());

  // TODO it's arguable if we should ever terminate update operations and risk getting into an inconsistent state
  const requestConfig: AxiosRequestConfig = { signal: request.signal };

  switch (formData[FormInputName.action]) {
    case ActiveSubscriptionFormActions.cancel.value:
      return cancelSubscriptionAction({ request, params });

    case ActiveSubscriptionFormActions.downgrade.value:
      // assuming that the billing address and the payment method are ok at this point,
      // see updateBillingInfoAction
      // await updatePaymentSourceAction(formData[BillingInputName.paymentSource], requestConfig);
      // await updateBillingAddressAction(formData[BillingInputName.billingAddress], requestConfig);
      return changeSubscriptionAction(
        {
          targetPlanSlug: formData[BillingInputName.targetPlanSlug],
          keepScheduledChanges: false
        },
        requestConfig
      );

    case ActiveSubscriptionFormActions.remove_scheduled_changes.value:
      return removeScheduledChangesAction({ request, params });

    case ActiveSubscriptionFormActions.renew.value:
      // assuming that the billing address and the payment method are ok at this point
      // see updateBillingInfoAction
      // await updatePaymentSourceAction(formData[BillingInputName.paymentSource], requestConfig);
      // await updateBillingAddressAction(formData[BillingInputName.paymentSource], requestConfig);
      // Preserve undefined when the form didn't send keepScheduledChanges — this lets
      // the billing service apply its smart default (keep only for Enterprise / Custom
      // / Extended Trial scheduled targets). Coercing missing to `false` would force
      // `removeScheduledChanges` even for Enterprise flows that rely on preservation.
      const rawKeepScheduledChanges = formData[BillingInputName.keepScheduledChanges];
      return renewSubscriptionAction(
        {
          subscriptionId: formData[BillingInputName.chargebeeSubscriptionId],
          coupons: [ formData[CouponInputName.couponCode] ],
          keepScheduledChanges: rawKeepScheduledChanges === undefined ? undefined : rawKeepScheduledChanges === "true"
        },
        requestConfig
      );

    case ActiveSubscriptionFormActions.upgrade.value:
      // assuming that the billing address and the payment method are ok at this point,
      // see updateBillingInfoAction
      return changeSubscriptionAction(
        {
          targetPlanSlug: formData[BillingInputName.targetPlanSlug],
          coupons: [ formData[CouponInputName.couponCode] ],
          keepScheduledChanges: false
        },
        requestConfig
      );


    default:
      return addToasterActionData<RouteErrors.RouterActionError>(
        {
          error: {
            message: `Unknown subscription action: ${ formData[FormInputName.action] }`
          }
        },
        {
          toastId: "unknown-billing-action-error",
          type: "error",
          title: "Error",
          description: "An unexpected error occurred. Please try again."
        }
      );
  }
};
